<template lang="html">
  <article class="" v-if="charged">
    <div class="agreement__new--title_container">
      <p class="accessIndex__text--title_clean" >Editar categoría</p>
    </div>
    <div >
      <label @click="$router.push({name: 'category'})" class="accessIndex__text--normal_user_gray">Categorías</label>
      <label class="accessIndex__text--normal_user_separator"> > </label>
      <label class="accessIndex__text--normal_user">Editar   {{category.attributes.name}}</label>

    </div>
    <section>

      <div class="agreement__new">
        <div class="agreement__new--column">
          <p class="agreement__text--small_gray">Nombre</p>
          <v-text-field
            single-line

            name="name"
            label="Nombre de la categoría"
            type="text"
            v-model="category.attributes.name"></v-text-field>
          <v-spacer></v-spacer>
          <!-- <v-switch
            label="Es subcategoría "
            class="data_card__switch offer_elements__text--label"
             v-model="category.attributes.is_sub"


          ></v-switch>
          <div v-if="category.attributes.is_sub">
            <v-select
              v-model="parent_category"
              :items="getCategories()"
              item-text="attributes.name"
              label="Categoria padre"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </div> -->
          <!-- <v-switch
            :label="`Publicada: ${category.attributes.published ? 'Si' : 'No'}`"
            v-model="category.attributes.published"
            class="data_card__switch offer_elements__text--label"

          ></v-switch> -->
          <v-spacer></v-spacer>
          <v-hover>
            <div slot-scope="{ hover }" @click="editCategory()" :class="hover?'agreement__interaction--hover':''" class="agreement__buttons--create_new">
              <p>Guardar</p>
            </div>
          </v-hover>
      </div>
    </div>
    </section>
  </article>
</template>

<script>
export default {
  data(){
    return{
      category: '',
      charged: false
    }
  },
  mounted(){
    var path = this.$route.path.split('/')
    try {
      this.$http.get('categories/'+ path[2],
        {headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}}
      ).then(function(response){
        this.category = response.body.data
        this.charged = true
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
      }, function(response){
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
        if(typeof response.body.errors[0].details != "object"){
          alert(response.body.errors[0].details);
        }else{
          let message = []
          for(var key in response.body.errors[0].details){
            message.push(response.body.errors[0].details[key])
          }
          alert(message);
        }
      })
      } catch (e) {
        alert(e.message)
      }
  },
  methods: {
    editCategory(){
      try {
        this.$http.patch('categories/'+ this.category.id, {data: this.encrypt(this.category).toString()},
          {headers:
            {"X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          this.$router.push({name: 'category'})
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/categories/Edit_category.vue